<div class="box-bottom-sheet-header-wrapper" [ngClass]="alignmentClass">
  <h1 *ngIf="title" class="box-bottom-sheet-header-title">{{ title | translate }}</h1>
  <div *ngIf="canClose" class="box-bottom-sheet-header-button-container close-button">
    <button mat-icon-button class="box-bottom-sheet-header-button" (click)="onDismiss($event)">
      <mat-icon fontSet="material-icons-round">close</mat-icon>
    </button>
  </div>
</div>
